import { DendromapLoader } from '@repo/ui/components/dendromap-loader';
import { lazy, Suspense } from 'react';

const AiSettingsPage = lazy(() =>
  import('@repo/ui/features/ai/settings').then((mod) => ({ default: mod.AiSettingsPage })),
);

export default function AiSettingsRoute() {
  return (
    <Suspense fallback={<DendromapLoader message="Chargement des paramètres IA..." />}>
      <AiSettingsPage />
    </Suspense>
  );
}
